import {DataTransferObjectValidation} from "../../../type/Types";
import {ShoppingPathBrowserValueObject} from "../../vo/content/ShoppingPathBrowserValueObject";

export namespace ShoppingPathBrowserDataTransferObject {
    export type Post = {
        shoppingPathId: bigint
        osType: string | null
        browser: string | null
        weight: number | null
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = ShoppingPathBrowserValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            shoppingPathId(o: string): bigint | Error {
                try {
                    return BigInt(o)
                } catch (e) {
                    return new Error('shoppingPathId', { cause: e })
                }
            },
            osType(o: string): string | null | Error {
                if (o.length === 0) {
                    return null
                }

                return o
            },
            browser(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            weight(o: string): number | null {
                if (o.length === 0) {
                    return null
                } else {
                    return Number(o)
                }
            },

        }
    }

    export type Put = {
        osType: string | null
        browser: string | null
        weight: number | null
    }

    export namespace Put {
        export const description: Record<keyof Put, string> = ShoppingPathBrowserValueObject.description

        export const validation: DataTransferObjectValidation<Put> = {
            osType(o: string): string | null | Error {
                if (o.length === 0) {
                    return null
                }

                return o
            },
            browser(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            weight(o: string): number | null {
                if (o.length === 0) {
                    return null
                } else {
                    return Number(o)
                }
            },
        }
    }
}

